// Common
import { PageWithAppBar } from '$common/page-with-app-bar'
import { RoomProfileHeader } from '$common/room-profile-header'
import { SettingsSection } from '$common/settings-section'
// Localization
import { t } from '$i18n'
// Helpers
import { getImageUrl } from '$func/imageUrl'
import { useWapp } from '$logic/wapps/react-hook'
import { closeWappProfile } from '$logic/router'
import { showWappProfileMenu } from '$comp/modals/menus/wapp-profile-menu'
import { stringToColor } from '$func/string-to-color'
import { useWappRoomByWappId } from '$logic/wapp-room/react-hook'
// Components
import { WappProfileInfo } from './wapp-profile-info'
import { WappProfileNotification } from './wapp-profile-notification'
import { WappProfileActions } from './wapp-profile-actions'

export function WappProfile({ wappId }: { wappId: string }) {
  const { entity: wapp } = useWapp(wappId)
  const { entity: wappRoom } = useWappRoomByWappId(wappId)

  const avatarBackground = stringToColor(wapp?.name, wappRoom?.roomId)
  return (
    <PageWithAppBar
      appBar={
        <RoomProfileHeader
          avatarSrc={getImageUrl(wapp?.image)}
          avatarBackground={avatarBackground}
          primaryText={wapp?.name || ''}
          onBack={closeWappProfile}
          secondaryText={`${t('profile.wapp.tool')}`}
          onMenu={() => showWappProfileMenu({ wappId })}
        />
      }
    >
      <SettingsSection>
        <>
          <WappProfileInfo description={wapp?.description} />
          <WappProfileNotification wappId={wappId} />
        </>
      </SettingsSection>
      <SettingsSection>
        <WappProfileActions wappId={wappId} />
      </SettingsSection>
    </PageWithAppBar>
  )
}
